import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, Star, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';
import TrustpilotWidget from './TrustpilotWidget';

export default function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  
  const testimonials = [
    {
      quote: "Excellent way to get more confidence and align your trading style to become more structured. Thanks Sinu for all your quick help and support. I really felt someone who understand the pain i am going through and shows me the correct path",
      author: "Verified Buyer",
      date: "21 January 2026",
      rating: 5,
      verified: true,
      testId: "testimonial-1"
    },
    {
      quote: "Having been part of the community for quite some time now, it has genuinely been of value. The Morning Messages give me clarity each morning to start my day, while the live sessions leave me with practical insights I can apply right away. MYeAI Trading Compass is a game-changer, so simple to use yet so powerful in guiding decisions.",
      author: "Verified Buyer",
      date: "3 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-2"
    },
    {
      quote: "The MyeAI Trading Compass has completely transformed the way I organize and plan my trades. It gives me clear direction and helps me stay consistent. Really impressed with the team behind it and the value they're delivering.",
      author: "Verified Buyer",
      date: "3 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-3"
    },
    {
      quote: "MyEA Trading Compass has genuinely exceeded my expectations. The platform is beautifully designed, incredibly intuitive, and very easy to navigate. Everything is laid out clearly, and the dashboard provides exactly the kind of insights and structure I was looking for.",
      author: "Verified Buyer",
      date: "3 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-4"
    },
    {
      quote: "Outstanding Support, Guidance & Community. Every morning message gives a clear outlook, actionable insights, and a structured plan for the day. The live sessions are incredibly valuable — not just for the trades, but for understanding why certain decisions are made.",
      author: "Verified Buyer",
      date: "26 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-5"
    },
    {
      quote: "Amazing tool for those who lost their path in trading. Such an amazing tool for any body in trading. It does the job of a compass. Guiding to the right path when we are lost.",
      author: "Verified Buyer",
      date: "26 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-6"
    },
    {
      quote: "Honestly, these guys made really good learning platform. Tracking the progress and mistakes is amazing.",
      author: "Verified Buyer",
      date: "15 January 2026",
      rating: 5,
      verified: true,
      testId: "testimonial-7"
    },
    {
      quote: "I've witnessed the MYeAI Trading Compass team's efforts to assist our community as a part of the team. The insights, webinars, and advice already offer value, even if the platform is still developing and has potential for improvement.",
      author: "Verified Buyer",
      date: "7 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-8"
    },
    {
      quote: "I appreciate most the transparency and consistency I receive. I would recommend this most to anyone looking for structured guidance and confidence in your journey.",
      author: "Verified Buyer",
      date: "3 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-9"
    },
    {
      quote: "What impressed me most is how smoothly everything runs. The tools are well-built, reliable, and deliver consistent performance. It's clear that a lot of thought went into creating a system that feels professional, efficient, and user-friendly.",
      author: "Verified Buyer",
      date: "15 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-10"
    },
    {
      quote: "This particular project is helping traders alot and specially Founder and CEO of this project help traders personally on each and every doubts so yes this is the best help and support we are getting from the MYeAI.",
      author: "Verified Buyer",
      date: "2 December 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-11"
    },
    {
      quote: "I was new with all the terminologies and this has really helped me breakdown each information and learn from the beginning. Sessions were very informative & explained in detail for any new person starting to learn trading.",
      author: "Verified Buyer",
      date: "21 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-12"
    },
    {
      quote: "Learned extremely valuable information on trading.",
      author: "Verified Buyer",
      date: "21 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-13"
    },
    {
      quote: "What makes this community special is how supportive and practical everything is. From the daily messages to the live webinars, I've gotten so much actionable value. The MyeAI Trading Compass in particular helped me bring structure to my trading.",
      author: "Verified Buyer",
      date: "25 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-14"
    },
    {
      quote: "A fusion of trading and networking built into one platform. Would highly recommend to all everyone.",
      author: "Verified Buyer",
      date: "18 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-15"
    },
    {
      quote: "This is one of the best human indicators for traders, even as a beginner it shows valuable insights from other professional traders, makes your decision process easy and straightforward, can't find this anywhere else.",
      author: "Verified Buyer",
      date: "25 November 2025",
      rating: 5,
      verified: true,
      testId: "testimonial-16"
    }
  ];

  // Show first 5 or all testimonials based on state
  const displayedTestimonials = showAll ? testimonials : testimonials.slice(0, 5);

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.4 }}
          className="text-center mb-12"
        >
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#337AF7] tracking-tight mb-4"
            data-testid="testimonials-title"
          >
            What Traders Experience Inside
          </h2>
          
          {/* Trustpilot Rating */}
          <div className="flex items-center justify-center gap-3">
            <img 
              src="https://cdn.trustpilot.net/brand-assets/4.1.0/logo-black.svg" 
              alt="Trustpilot" 
              className="h-6"
            />
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-green-500 text-green-500" />
                ))}
              </div>
              <span className="text-[#162959] font-semibold">4.5</span>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence mode="sync">
            {displayedTestimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.testId}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4, delay: index < 5 ? (index % 6) * 0.08 : (index - 5) * 0.05 }}
                data-testid={testimonial.testId}
                className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-200 p-6 flex flex-col"
              >
                {/* Rating Stars */}
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-green-500 text-green-500" />
                  ))}
                </div>

                {/* Quote */}
                <Quote className="h-6 w-6 text-[#337AF7]/30 mb-2" />
                <p className="text-sm md:text-base text-[#162959]/80 mb-4 flex-1">
                  "{testimonial.quote}"
                </p>

                {/* Author & Date */}
                <div className="border-t border-slate-200 pt-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm font-semibold text-[#162959]">{testimonial.author}</div>
                      <div className="text-xs text-[#162959]/50">{testimonial.date}</div>
                    </div>
                    {testimonial.verified && (
                      <div className="flex items-center gap-1 text-xs text-green-600">
                        <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span>Verified</span>
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>

        {/* Show More / Show Less Button */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="mt-8 text-center"
        >
          <button
            onClick={() => setShowAll(!showAll)}
            data-testid="testimonials-toggle-button"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-slate-200 bg-white text-[#162959] font-medium hover:bg-slate-50 hover:border-slate-300 transition-all duration-200 shadow-sm"
          >
            {showAll ? (
              <>
                Show Less
                <ChevronUp className="h-5 w-5" />
              </>
            ) : (
              <>
                Show More
                <ChevronDown className="h-5 w-5" />
              </>
            )}
          </button>
        </motion.div>

        {/* View All on Trustpilot */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-8 text-center"
        >
          {/* Trustpilot Widget */}
          <TrustpilotWidget />
          
          <a
            href="https://uk.trustpilot.com/review/myeaitradingcompass.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#337AF7] hover:text-[#162959] transition-colors text-sm font-medium mt-4"
            data-testid="trustpilot-link"
          >
            View all reviews on Trustpilot
            <ExternalLink className="h-4 w-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}